/**
 * v-data-table headers for the Release Notes list (`/manage-release-notes`).
 *
 * Sorting is deliberately disabled on every column: `GET api/Management/Releases` only accepts
 * `status`, `search`, `page` and `itemsPerPage`, so a sortable header would render a control that
 * refetches without changing the order. Re-enable per column once the API supports sorting.
 */
export default [
  {
    text: 'Name',
    value: 'name',
    align: 'left',
    sortable: false,
    order: 0,
    hidable: false,
    hidden: false,
  },
  {
    text: 'Status',
    value: 'status',
    width: '180px',
    align: 'left',
    sortable: false,
    order: 1,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Jira version',
    value: 'jiraVersionName',
    width: '200px',
    align: 'left',
    sortable: false,
    order: 2,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Last published',
    value: 'lastPublishedAt',
    width: '160px',
    align: 'left',
    sortable: false,
    order: 3,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Created',
    value: 'createdAt',
    width: '160px',
    align: 'left',
    sortable: false,
    order: 4,
    hidable: true,
    hidden: false,
  },
];
